<ng-container *ngFor="let sensor of hourlyAlertSensors">
  <app-site-detail-tilt-alert-hourly
    [date]="sensor.hourlyAlertDate!"
    [positionName]="sensor.positionName"
  ></app-site-detail-tilt-alert-hourly>
</ng-container>

<ng-container *ngFor="let sensor of managementAlertSensors">
  <app-site-detail-tilt-alert-standard
    [date]="sensor.managementAlertDate!"
    [positionName]="sensor.positionName"
  ></app-site-detail-tilt-alert-standard>
</ng-container>
